import React, { Component } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { ITag} from '../../core/models/tag';
import {
  withStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Typography,
  Paper,
  IconButton,
  Tooltip,
  lighten,
  Popover,
  Grid,
  InputBase
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { Dispatch } from 'redux';
import { REMOVE_TAG } from '../../core/handlers.actions';
import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Link } from 'react-router-dom';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';

const styles = (theme: any) => ({
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute' as any,
    top: 20,
  },
  toolBarRoot: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.primary.main,
        backgroundColor: lighten(theme.palette.primary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.primary.dark,
      },
  title: { flex: '1 1 100%' },
  tableRoot: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableVisuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute' as any,
    top: 20,
    width: 1,
  },
  actionRow: {
    display: 'inline-flex' as any
  },
  okButton: {
    color: 'green'
  },
  xButton: {
    color: 'red'
  },
  search: {
    position: 'relative' as any,
    borderRadius: theme.shape.borderRadius,
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute' as any,
    pointerEvents: 'none' as any,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  }
});

interface Props {
  tags: any;
  classes: any;
  deleteTag: (tagId:string) => void;  
  editTag: (tag:ITag) => void;
}

interface State {
  headers: any;
  numSelected: number;
  order: Order;
  orderBy: string;
  selected: any;
  page: number;
  dense: boolean;
  rowsPerPage: number;
  rows: any;
  popoverElement: any;
  popoverOpen: boolean;
  popevercurrentItem:any;
  filtered:any;
}

interface HeadCell {
  disablePadding: boolean;
  id: keyof ITag;
  label: string;
  numeric: boolean;
}

const headCells: HeadCell[] = [
  { id: 'name', disablePadding: false, label: 'Name', numeric: false },
  { id: 'description', disablePadding: false, label: 'Description', numeric: false },
  { id: 'slug', disablePadding: false, label: 'Slug', numeric: false },
  { id: 'totalPosts', disablePadding: false, label: 'Count', numeric: true },
  { id: 'createdAt', disablePadding: false, label: 'Created At', numeric: false },
  { id: 'updatedAt', disablePadding: false, label: 'Last updated At', numeric: false }
];

type Order = 'asc' | 'desc';

class TagTable extends Component<Props, State> {
  state: State = {
    headers: headCells,
    numSelected: 0,
    orderBy: 'name',
    order: 'asc',
    selected: [],
    page: 0,
    dense: false,
    rowsPerPage: 5,
    rows: [],
    popoverElement: undefined,
    popoverOpen: false,
    popevercurrentItem: '',
    filtered:[]
  }

  constructor(props: Props) {
    super(props);
    this.createTableHeader = this.createTableHeader.bind(this);
    this.descendingComparator = this.descendingComparator.bind(this);
    this.getComparator = this.getComparator.bind(this);
    this.stableSort = this.stableSort.bind(this);    
    this.createToolbar = this.createToolbar.bind(this);
    this.handleRequestSort = this.handleRequestSort.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.pagerHandler = this.pagerHandler.bind(this);
    this.rowsPerPagehandler = this.rowsPerPagehandler.bind(this);
    this.handleOpenPopover = this.handleOpenPopover.bind(this);
    this.handleClosePopover = this.handleClosePopover.bind(this);
    this.renderHtml = this.renderHtml.bind(this);
    this.editTagHandler = this.editTagHandler.bind(this);
    this.filter = this.filter.bind(this);
  }

  public editTagHandler(id:string){
    const {tags, editTag} = this.props;
    const tag = tags.find((tag: ITag) => tag._id === id);
    editTag(tag);
  }

  public renderHtml(data:any) {
    return {__html: data};
  }

  public handleRequestSort(event: React.MouseEvent<unknown>, property: keyof ITag) {
    const { orderBy, order } = this.state;
    const isAsc = orderBy === property && order === 'asc';
    this.setState({ ...this.state, order: isAsc ? 'desc' : 'asc', orderBy: property });
  }

  public descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  }

  public stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  public getComparator<Key extends keyof any>(order: Order, orderBy: Key): (a: { [key in Key]: number | string }, b: { [key in Key]: number | string }) => number {
    return order === 'desc' ? (a, b) => this.descendingComparator(a, b, orderBy) : (a, b) => -this.descendingComparator(a, b, orderBy);
  }

  public filter(e:any){
    const {tags} = this.props;
    const filtered = tags.filter((item:ITag) => item.name.toLowerCase().includes(e?.target.value));
    this.setState({...this.state, filtered: filtered});
  }

  public createTableHeader() {
    const { headers, orderBy, order } = this.state;
    const { classes } = this.props;
    return (
      <TableHead>
        <TableRow>          
          {headers.map((headCell: any) => (
            <TableCell
              key={headCell.id}
              align={headCell.numeric ? 'right' : 'left'}
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === headCell.id ? order : false}>

              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={(e) => this.handleRequestSort(e, headCell.id)}>
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
          <TableCell
              key={'actions'}
              align={'left'}
              padding={'none'}>
              Actions
            </TableCell>
        </TableRow>
      </TableHead>
    );
  }

  public createToolbar() {
    const { classes, deleteTag, editTag } = this.props;
    const { selected } = this.state;
    return (
      <Toolbar
        className={clsx(classes.toolBarRoot, {
          [classes.highlight]: selected.length > 0,
        })}>
        {selected.length > 0 ? (
          <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
            {selected.length} selected
          </Typography>
        ) : (
          <Grid container>
            <Grid item xs={6} sm={6}>
              <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
                  Tags
                </Typography>
            </Grid>
            <Grid item xs={6} sm={6} container
                direction="row"
                justify="flex-end"
                alignItems="center">
                <div className={classes.search}>
                  <div className={classes.searchIcon}>
                    <SearchIcon />
                  </div>
                  <InputBase
                    placeholder="Search…"
                    classes={{
                      root: classes.inputRoot,
                      input: classes.inputInput,
                    }}
                    inputProps={{ 'aria-label': 'search' }}
                    onChange = {this.filter}
                  />
                </div>
            </Grid>
          </Grid>               
          )}
        {selected.length === 1 ? (
          <div className={classes.actionRow}>
            <Tooltip title="Edit">
              <IconButton aria-label="edit" onClick = {() => {editTag(selected[0]); console.log(selected[0])}}>
                <EditIcon color="primary"/>
              </IconButton>
            </Tooltip>
            <Tooltip title="View">
              <Link to={`/wall/${selected}`}>
                <IconButton aria-label="show">
                  <VisibilityIcon className={classes.okButton}/>
                </IconButton>
              </Link>                
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton aria-label="delete" onClick = {() => deleteTag(selected)}>
                <DeleteIcon className={classes.xButton}/>
              </IconButton>
            </Tooltip>
          </div>
          
        ): null}
      </Toolbar>
    );
  }

  public rowClick(event: React.MouseEvent<unknown>, id: string) {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    this.setState({ ...this.state, selected: newSelected });
  }

  public pagerHandler(event: unknown, newPage: number) {
    this.setState({ ...this.state, page: newPage });
  }

  public rowsPerPagehandler(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ ...this.state, page: 0, rowsPerPage: parseInt(event.target.value, 10) });
  }

  public handleOpenPopover(event: React.MouseEvent<HTMLButtonElement>){  
    const currentEventId = event.currentTarget.getAttribute('aria-describedby');
    this.setState({ ...this.state, popevercurrentItem: currentEventId, popoverElement: event.currentTarget, popoverOpen: Boolean(event.currentTarget)});
  }

  public handleClosePopover(){
    this.setState({ ...this.state, popoverElement: null, popoverOpen: false});
  }

  public render() {
    const { order, orderBy,  page, dense, rowsPerPage, popoverOpen, popoverElement, popevercurrentItem, filtered} = this.state;
    const { classes, tags, deleteTag } = this.props;        
    return (
      <div className={classes.tableRoot}>        
        <Paper className={classes.paper}>
          {this.createToolbar()}
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={dense ? 'small' : 'medium'}
              aria-label="enhanced table">
              {this.createTableHeader()}
              <TableBody>
                {this.stableSort((filtered.length === 0)?tags:filtered, this.getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: any, index: number) => {                      
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        hover           
                        tabIndex={-1}
                        key={row.name}>
                        <TableCell id={labelId} scope="row">{row.name}</TableCell>
                        <TableCell align="left"  dangerouslySetInnerHTML={this.renderHtml(row.description)} />
                        <TableCell align="left"  dangerouslySetInnerHTML={this.renderHtml(row.slug)} />
                        <TableCell align="right" >{row.totalPosts}</TableCell>
                        <TableCell align="left" >{moment(row.createdAt).format('ll')}</TableCell>
                        <TableCell align="left" >{moment(row.updatedAt).format('ll')}</TableCell>
                        <TableCell align="left">
                        <Tooltip title="More Actions">
                          <IconButton aria-label="More Actions" aria-describedby={row._id} onClick={this.handleOpenPopover}>
                            <MoreVertIcon className={classes.xButton}/>
                          </IconButton>
                        </Tooltip>                                                                   
                        </TableCell>
                      </TableRow>
                    );
                  })}   
                  <Popover 
                          id='simple-popover'
                          open={popoverOpen} 
                          anchorEl={popoverElement} 
                          onClose={this.handleClosePopover}
                          anchorOrigin={{ vertical: 'bottom', horizontal: 'center'}}
                          transformOrigin={{ vertical: 'top', horizontal: 'center'}}>   
                            <Tooltip title="Edit">
                              <IconButton aria-label="Edit"  onClick={() => {this.editTagHandler(popevercurrentItem); this.handleClosePopover(); }}>
                                <EditIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete Tag">
                              <IconButton aria-label="Delete Tag"  onClick={() => {deleteTag(popevercurrentItem); this.handleClosePopover();}}>
                                <DeleteIcon  className={classes.xButton}/>
                              </IconButton>
                            </Tooltip> 
                  </Popover>                 
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15, 25]}
            component="div"
            count={(filtered.length === 0)?tags.length: filtered.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={this.pagerHandler}
            onChangeRowsPerPage={this.rowsPerPagehandler} />
        </Paper>        
      </div>
    );
  }
}

const mapProps = (app: any) => ({ tags: app.rootReducer.tags});
const actions = (dispatch: Dispatch) => ({
  deleteTag: (tagId: string) => dispatch({type: REMOVE_TAG, payload: tagId})
});
export default connect(mapProps, actions)(withStyles(styles)(TagTable)); 